import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';

function clickOnSelectMyTyreClick() {
    const category = GA_EVENTS.selectFsInfoLightBox.category;
    const action = GA_EVENTS.selectFsInfoLightBox.actions.clickOnSelectMyTyreClick;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function clickOnContinueShopping() {
    const category = GA_EVENTS.selectFsInfoLightBox.category;
    const action = GA_EVENTS.selectFsInfoLightBox.actions.clickOnContinueShopping;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function close() {
    const category = GA_EVENTS.selectFsInfoLightBox.category;
    const action = GA_EVENTS.selectFsInfoLightBox.actions.close;
    const label = PageTypeFactory.getPageType();

    setBehaviourEvent({ category, action, label });
}

function open(from) {
    const category = GA_EVENTS.selectFsInfoLightBox.category;
    const action = GA_EVENTS.selectFsInfoLightBox.actions.open;
    const label = `Opened from within ${from}`;

    setBehaviourEvent({ category, action, label });
}

export {
    clickOnSelectMyTyreClick,
    clickOnContinueShopping,
    close,
    open
};
